var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"status"},_vm._l((_vm.roles),function(role){return _c('li',{key:role.id},[_c('checkbox',{attrs:{"value":role.id,"name":"roles","color":"#000000"},model:{value:(_vm.val),callback:function ($$v) {_vm.val=$$v},expression:"val"}},[_vm._v(_vm._s(role.title))])],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }